<template lang="pug">
  div.small-modal.opened
    div.small-modal__body
      e-form(:formValidator="formValidator")
        e-form-group(
          name="mass"
          inputType="input"
          label="Масса отходов для транспортирования"
          :model="fields"
          tabView="tab1"
          validationRule="double"
        )
        e-form-group(
          name="service_cost"
          inputType="input"
          label="Стоимость одного часа работы обслуживающего персонала транспорта"
          :model="fields"
          tabView="tab1"
          :required="true"
          validationRule="double"
        )
        e-form-group(
          name="fuel_cost"
          inputType="input"
          label="Стоимость топлива за литр"
          :model="fields"
          tabView="tab1"
          :required="true"
          validationRule="double"
        )
      div.empty(v-if="isEmpty") Результатов нет
      div.middle(v-if="min_count")
        div.min-count Минимальное число мусоровозов для выполнения транспортной работы - {{min_count}}
        .table
          table
            thead
              tr
                th Модель
                th Государственный номер
                th Стоимость
                th Вместимость
            tbody
              tr(v-for="transport in transports" :key="transport.id")
                td {{transport.model}}
                td {{transport.number || '-'}}
                td {{transport.cost || '-'}}
                td {{transport.capacity || '-'}}
    div.small-modal__footer
      button(type="button" @click="$emit('close')").reset-btn.button.button_no-border.button_color.modal__button Отмена
      button(type="button" @click="sendForm()").button.reset-btn.button_usual.modal__button Рассчитать
</template>

<script>
import formBaseMixin from '@/components/form/form-base-mixin'
import { transport } from '@/api/api-endpoints'

export default {
  name: 'transport-choose',
  mixins: [formBaseMixin],
  props: {
    routeId: Number,
  },
  data: () => ({
    fields: {
      mass: '',
      service_cost: '',
      fuel_cost: '',
    },
    min_count: null,
    transports: [],
    isEmpty: false,
  }),
  methods: {
    async sendForm() {
      try {
        let { data } = await this.$store.dispatch('createModel', {
          url: transport.optimalTransports(),
          data: { ...this.fields, route_id: String(this.routeId) },
        })
        this.min_count = data.min_count
        this.transports = data.transports
        this.isEmpty = !this.transports.length
      } catch (e) {
        this.transports = []
        this.min_count = null
        this.isEmpty = false
        const text = Object.values(e.data.errors).reduce((acc, item) => {
          acc += item + '\n'
          return acc
        }, '')
        this.$e.errorBox(text)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.small-modal.open.transport-choose-modal {
  position: fixed;
  transform: translateX(-50%) translateY(-50%);
  background-color: #fff;
  z-index: 2;

  table {
    margin: 0;
  }
}

.min-count {
  margin-bottom: 10px;
}

.middle,
.empty {
  padding: 20px 40px;
}

.table {
  max-height: 270px;
  overflow: hidden;
  overflow-y: auto;

  &::-webkit-scrollbar {
    height: 6px;
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 6px;
    box-shadow: inset 0 0 6px rgba(170, 170, 170, 0.6);
  }
}

thead {
  position: sticky;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: 2;
}
</style>
